import apiClient from '@/services/apiClient'
import type { DeliveryOverlay } from '@/types'
import { EMPTY_OVERLAY } from '@/utils/deliveryOverlay'

/**
 * DF-345: the Christmas delivery-calendar overlays for the signed-in customer
 * (round day amendments and glass substitution). The CRM iframe gets the same
 * data bundled in its own endpoint.
 */
const deliveryOverlayService = {
  async getOverlay(): Promise<DeliveryOverlay> {
    const response = await apiClient.get('/api/auth/delivery-overlay')
    return (response as unknown as { data?: DeliveryOverlay }).data
      ?? EMPTY_OVERLAY
  },
}

export default deliveryOverlayService
